const prefix = "/messages";

export const MESSAGE_ENDPOINTS = {
  BASE: prefix,
};

export const MESSAGES_QUERIES = {
  GET_MESSAGES: "GET_MESSAGES",
};
